// The string values are so we could send these values (e.g - for analytics)
export var WelcomeCenterUILocations;
(function (WelcomeCenterUILocations) {
    WelcomeCenterUILocations["Bar"] = "bar";
    WelcomeCenterUILocations["Modal"] = "modal";
})(WelcomeCenterUILocations || (WelcomeCenterUILocations = {}));
export var WelcomeFlowStep;
(function (WelcomeFlowStep) {
    WelcomeFlowStep[WelcomeFlowStep["First"] = 0] = "First";
    WelcomeFlowStep[WelcomeFlowStep["Second"] = 1] = "Second";
    WelcomeFlowStep[WelcomeFlowStep["Third"] = 2] = "Third";
    WelcomeFlowStep[WelcomeFlowStep["End"] = 3] = "End";
})(WelcomeFlowStep || (WelcomeFlowStep = {}));
//# sourceMappingURL=tour-welcome-center.enum.js.map